import type { FieldProps } from 'formik';

import {
  NumberInput as ChakraNumberInput,
  NumberInputField,
  Skeleton,
} from '@frontend/components';

import { useFeatureFlagFormContext } from 'modules/common/drawers/featureFlagDrawer/components/FormWrapper/FeatureFlagFormContext';
import {
  FeatureFlagData,
  FeatureFlagType,
} from 'modules/common/drawers/featureFlagDrawer/types';

export const NumberInput = ({
  field,
  form,
  flagData,
}: FieldProps<number> & {
  flagData: Extract<FeatureFlagData, { type: FeatureFlagType.Number }>;
}) => {
  const {
    featureFlagsQueryResult: { isLoading },
  } = useFeatureFlagFormContext();

  const { name: fieldName, value: fieldValue, onBlur } = field;
  const { setFieldValue } = form;

  if (!fieldName) {
    return null;
  }

  return (
    <Skeleton
      isLoaded={!isLoading}
      height={3}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
    >
      <ChakraNumberInput
        size="sm"
        inputMode="numeric"
        clampValueOnBlur={false}
        name={fieldName}
        value={fieldValue?.toString() ?? ''}
        onBlur={onBlur}
        onChange={(inputValue) => {
          if (inputValue === '') {
            setFieldValue(fieldName, null);
          } else {
            setFieldValue(fieldName, Number(inputValue));
          }
        }}
        min={flagData.min}
        maxW={8}
      >
        <NumberInputField />
      </ChakraNumberInput>
    </Skeleton>
  );
};
